import { render } from "./SettingsSlider.vue?vue&type=template&id=3da01951"
import script from "./SettingsSlider.vue?vue&type=script&lang=js"
export * from "./SettingsSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__